package com.devi3east.bashbuddy.auth.requests

import com.devi3east.bashbuddy.common.domain.models.Address
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class SignUpRequest(
    val email: String,
    val displayName: String,
    val password: String,
    val confirmPassword: String,
    val isOrganization: Boolean,

    val affiliatedOrganization: String? = null,

    val organizationName: String? = null,
    val contactPerson: String? = null,
    val organizationPhone: String? = null,
    val organizationAddress: Address? = null,
    val hasOrganizationAuthority: Boolean? = null,

    val name: String? = null,
    val phone: String? = null,
    val address: Address? = null,

    val dateOfBirthInstant: Instant? = null,
    val certifiedOfAge: Boolean = false,
    val agreedToTermsOfService: Boolean = false
)